import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setIsNotesDrawerOpen } from "../../reducers/common-reducer";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED } from "../../constants/Constants";

const NotesButton = ({ notesList }) => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { isNotesDrawerOpen, isRemoteParticipantJoined, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    const isNotesButtonVisibles = () => {
        return GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMENOTES === ENABLED;
    };

    return (
        <>
            {isNotesButtonVisibles() && (
                <div className='action-button note-action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn open-sidebar-button", isNotesDrawerOpen && "active")}
                            onClick={() => dispatch(setIsNotesDrawerOpen(!isNotesDrawerOpen))}
                            disabled={!isRemoteParticipantJoined || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-notes'></span>
                                {notesList.length > 0 && (
                                    <span className='count'>
                                        <span className='count-in'>{notesList.length}</span>
                                    </span>
                                )}
                            </span>
                            <span className='for-text'>{localisedValues["notes_lable"]}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

NotesButton.propTypes = {
    notesList: PropTypes.array,
};

export default NotesButton;
